import { SearchIcon, CloseIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Checkbox,
  CloseButton,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  Radio,
  RadioGroup,
  Text,
  VStack,
} from '@chakra-ui/react';
import {
  ChatMemberIcon,
  MyNetworkNewIcon,
  TeamIcon,
  TeamNewIcon,
} from '@mybridge/icons';

import { Avatar } from '@mybridge/ui';
import React, { useState } from 'react';
import MembersPopup from './members-popup';
import { useSelector } from 'react-redux';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

const MemberPopup = ({
  isMemberPopup,
  onClose,
  roomId,
  fetchRoomList,
  groupMemberDetail,
  getSelectedRoomMembersData
  //   isMembersPopupOpen,
  //   setIsMembersPopupOpen
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isCreateGroupedClicked, setIsCreateGroupedClicked] = useState(false);
  const [isMembersPopupOpen, setIsMembersPopupOpen] = useState(false);
  const [selectedMemberUserId, setSelectedMemberUserId] = useState(null);
  const [selectedMemberUserName, setSelectedMemberUserName] = useState(null);
  const [selectedMember,setSelectedMember]=useState(null);
  const { t } = useTranslator();
  const { userProfileInfo, userPresenceStatus } = useSelector(
    (state) => state.userProfile
  );
  const isAdmin = groupMemberDetail?.some(
    (member) =>
      member?.user_id === userProfileInfo?.id && (member?.role === 'admin'|| member?.role === 'owner')
  );
  const filteredMembers = groupMemberDetail?.filter((user) =>
    user?.display_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const displayUserDetail =`${isAdmin?"Admin":"Admin"}`
  return (
    <>
      <Modal isOpen={isMemberPopup} onClose={onClose}>
        {/* <ModalOverlay /> */}
        <ModalContent marginTop="150px">
          {/* <ModalCloseButton /> */}
          <ModalHeader>
            <HStack justifyContent="space-between">
              <Text
                fontFamily="Inter"
                fontSize="15px"
                fontWeight={600}
                lineHeight="18px"
                textAlign="left"
                textUnderlinePosition="from-font"
                textDecorationSkipInk="none"
                color="#5B5B5B"
              >
                {' '}
                {t('myMessages.members') || "Members"}
              </Text>
              <CloseIcon
                width={'10px'}
                height={'10px'}
                onClick={() => onClose()}
              />
            </HStack>
          </ModalHeader>
          <ModalBody>
            <HStack gap="10px" borderBottom="1px solid #E4E6EB" mb={3}>
              <SearchIcon w="18px" h="18px" />
              <Input
                placeholder={t('myMessages.searchPeople') || "Search people"}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                borderRadius="0px"
                border="unset"
                _focus={{
                  border: 'unset',
                }}
                backgroundColor="transparent"
              />
            </HStack>
            <VStack
              align="stretch"
              spacing={4}
              overflow={'auto'}
              sx={{
                '&::-webkit-scrollbar': {
                  width: '5px',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#C8C8C8',
                  borderRadius: '51px',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#555',
                },
                '&::-webkit-scrollbar-track': {
                  background: '#EDEDED',
                },
              }}
              height="45vh"
            >
              {filteredMembers?.map((user) => (
                <HStack
                  key={user?.id}
                  justifyContent="space-between"
                  cursor="pointer"
                  pr={2}
                >
                  <HStack spacing={3}>
                    <Avatar src={user?.avatar_url} name={user?.display_name} />
                    <Box>
                      <Text fontWeight="bold" fontSize="sm">
                        {user?.display_name}
                      </Text>
                      <Text fontSize="xs" color="gray.500">
                        {(user?.role==="admin"||user?.role==="owner")?"Admin":""}
                     {/* {user?.user_id!==userProfileInfo?.matrix_user_id ?"":displayUserDetail} */}
                      </Text>
                    </Box>
                  </HStack>
                  <Box
                    onClick={() => {
                      setIsMembersPopupOpen(true);
                      setSelectedMemberUserId(user?.id);
                      setSelectedMemberUserName(user?.display_name);
                      setSelectedMember(user);
                    }}
                  >
                    <ChatMemberIcon />
                  </Box>
                </HStack>
              ))}
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
      {
        <MembersPopup
          isMemberPopup={isMembersPopupOpen}
          roomId={roomId}
          selectedMember={selectedMember}
          groupMemberDetail={groupMemberDetail}
          fetchRoomList={fetchRoomList}
          isMembersPopupOpen={isMembersPopupOpen}
          setIsMembersPopupOpen={setIsMembersPopupOpen}
          selectedMemberUserId={selectedMemberUserId}
          selectedMemberUserName={selectedMemberUserName}
          onClose={onClose}
          getSelectedRoomMembersData={getSelectedRoomMembersData}
        />
      }
    </>
  );
};

export default MemberPopup;
